export const brandViewerAccessText = "You don’t have enough permissions";
